import React from "react"
import Seo from "../../components/seo"
import Layout from "../../components/layout"
import KeyMethodLink from "../../components/key-method-link"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import { Link } from "gatsby"
import "../../styles/pc/page/key_method.scss"
import "../../styles/sp/page/key_method.scss"

export default function ReflectionAndDialogPage() {
  return (
    <Layout>
      <Seo
        type="article"
        title="それぞれのKeyMethodの紹介 内省と対話"
        description=""
        bobyClassName="menu20"
        path="key-method/reflection-and-dialog"
      />
      <div className="wrapper">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/philosophy#key_method_ttl">key-method</Link>　/　<Link to="/key-method/reflection-and-dialog" className="current">内省と対話</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        <div className="catch1">
          <div className="catch1_in">
            <div className="catch_title">
              <h2 className="maintitle"><span>Key Method</span></h2>
              <p className="subtitle"><span>キーメソッド</span></p>
            </div>
          </div>{/* catch_in */}
        </div>{/* /catch1 */}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
            {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
            <div className="contents contents_wrap">
              <div className="contents_in">
                <div className="padding_sp">{/* スマホのみ隙間 */}
                  <div className="wrap_box w670">
                    <div className="inner_title">
                      <div className="inner_title_in">
                        <h5 className="maintitle_left"><span>内省と対話</span></h5>
                      </div>
                    </div>
                    <div className="cnt_box">
                      <p>組織の一体感が希薄である、コミュニケーションが難しくなった、セルフコントロールできない人が増えている等と、仕事を進めるうえで困難な状況が増えてきています。</p>
                      <p>こういった現状を変えていくには、一人ひとりがまず<span className="redBold">自分を知り、他人を知る</span>ことが出発点となります。</p>
                      <p>特に組織をリードするマネジャーにとっては不可欠なことで、自分を見つめること、すなわち<span className="redBold">内省の習慣</span>が大切です。しかし、ただ自分を見つめるというのは容易ではなく、自分の行動という事実をベースに振り返ることが有効です。</p>
                      <p>内省する時に重要なのは、次の2点です。</p>
                      <dl className="box bottom_20px">
                        <dt>1. 事実と感情を峻別して振り返る</dt>
                        <dd>人の記憶は五感をベースにした感情とともに埋め込まれているので、まずは事実と感情をわけることから始めます。客観的事実を取り出すことができれば、なぜその時に自分の中にその感情が沸き起こったのかを振り返り、分析することが可能になります。自分の中にある固定観念に気づく第一歩なのです。</dd>
                      </dl>
                      <dl className="box bottom_40px">
                        <dt>2. 過去と現在それぞれの感情を振り返る</dt>
                        <dd>客観視を始めると、「今思うに・・だった」という気持ちが生まれてくることがあります。今度、同じ状況になったら次はこうしようという、より良い行動への気づきが生まれます。</dd>
                      </dl>
                      <p>このプロセスは自分でも行えるのですが、より効果的に行う手段が<span className="redBold">対話</span>です。</p>
                      <p>1対1でもよいのですが、自分が振り返った内容を開示することによって多くのフィードバックを得ることが可能になるので、できれば複数の人に投げかけることが望ましいと言えます。話し手は自分の内省のプロセスを開示し、それに対して聴き手は自分と対比しながら、問い返したりフィードバックを行ったりします。</p>
                      <p>このサイクルを繰り返していくことによって、自らの経験に学ぶ<span className="redBold">「経験学習」のサイクル</span>が身についていきます。内省したことを日々の実践の中に活かすことによって、もう一段高いレベルの経験が生まれ、新たな内省が可能になります。</p>
                      <p className="bottom_56px">この時、内省がルーチン化することを避けるために、常に定期的に新たな<span className="redBold">刺激（視点）</span>を外から呼び込んでくるしかけはとても大切で、これが限りない成長の原動力になります。</p>
                      <LazyAndPreloadImage className="Img_key-method m_btm80_pc m_btm64_sp" imgUrl={"/images/key-method/image_keyconcept4.gif"} alt="経験学習のサイクル" />
                    </div>
                  </div>
                </div>{/* padding_sp スマホのみ隙間 */}
              </div>{/* contents_in */}
            </div>{/* /contents */}
            {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
            <KeyMethodLink />
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">Key Method - </span><span className="txt">キーメソッド</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}
